import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Segment, Header, Image, Button } from "semantic-ui-react"
import {
  DropitState,
  getUserRole,
  getTranslationsByScope,
} from "../core/reducers"
import maintenanceImg from "../core/assets/maintenance.jpg"
// import { $deactivateMaintenance } from "../../../core/requests"
import { ITranslations } from "../models"
import { Roles } from "../utils"

const MaintenancePage = (props: {
  role: Roles
  //   refreshToHome: () => string
  translations: ITranslations["global"]
}) => {
  //   const isMarketLeader = props.role === Roles.MARKET_LEADER
  return (
    <Segment className="maintenance-page">
      <div className="maintenance-header">
        <Header>{props.translations.maintenanceHeader}</Header>
        <Header>{props.translations.maintenanceBody}</Header>
      </div>
      <div className="maintenance-image">
        <Image src={maintenanceImg} />
      </div>
      {/* {isMarketLeader && (
        <Button
          //   onClick={$deactivateMaintenance}
          inverted
          style={{ position: "absolute", left: "9%", top: "60%" }}
        >
          {"[CM] Réactiver eSesame"}
        </Button>
      )} */}
    </Segment>
  )
}

const mapStateToProps = (state: DropitState) => ({
  role: getUserRole(state),
  translations: getTranslationsByScope(state, "global"),
})

//   const mapDispatchToProps = {
//     fetchSupplierParameters
//   }

export default withRouter<any & any>(
  connect(
    mapStateToProps,
    undefined
    //   mapDispatchToProps
  )(MaintenancePage)
)
